import React from "react";
import { classNames } from "../styles/classNames";

type DropdownAlign = "left" | "right";
type DropdownWidth = "sm" | "md" | "lg" | "full";
/** Which side of its anchor the popover opens. */
type DropdownSide = "below" | "above";

interface DropdownPopoverProps {
  open: boolean;
  align?: DropdownAlign;
  width?: DropdownWidth;
  side?: DropdownSide;
  className?: string;
  children: React.ReactNode;
}

const WIDTH_CLASS: Record<DropdownWidth, string> = {
  sm: "app-dropdown-popover-sm",
  md: "app-dropdown-popover-md",
  lg: "app-dropdown-popover-lg",
  full: "app-dropdown-popover-full",
};

export default function DropdownPopover({
  open,
  align = "right",
  width = "md",
  side = "below",
  className,
  children,
}: DropdownPopoverProps) {
  if (!open) {
    return null;
  }

  return (
    <div
      className={classNames(
        "app-dropdown-popover",
        align === "right" ? "app-dropdown-popover-right" : "app-dropdown-popover-left",
        WIDTH_CLASS[width],
        side === "above" && "app-dropdown-popover-above",
        className
      )}
    >
      <div className="app-dropdown-panel">{children}</div>
    </div>
  );
}
